import React from 'react'
import { TableRow, TableCell, Tooltip } from '@mui/material'

const errorBorder = "solid #ef5350 1px !important"

interface PreviewItemProps {
  column: Map<string, string>
  item: any
}

export function PreviewItem({ item, column }: PreviewItemProps): JSX.Element {

  const itemElement: JSX.Element[] = []
  const isDuplicateError = item.errors && item.errors.includes('DUPLICATE_LINE_ITEM')

  column.forEach((itemKey: string, displayedColumn: string, __) => {
    let value = item[itemKey]
    if (Array.isArray(value)) {
      value = value.toString()
    }
    const isCellError = item.errors && item.errors.toLocaleLowerCase().includes(itemKey.toLocaleLowerCase())
    let errorMessage = item.errors?.replace(itemKey, displayedColumn.toUpperCase()) || null
    if (isDuplicateError) {
      errorMessage = 'duplicated line item'
    }

    itemElement.push(
      <Tooltip title={isCellError || isDuplicateError ? errorMessage : ''}>
        <TableCell sx={{
          borderBottom: 'none',
          border: isCellError ? errorBorder : null,
        }}>
          {
            value instanceof Date ?
              value.toLocaleDateString() :
              value === true ?
                'TRUE' :
                value === false ?
                  'FALSE' :
                  value
          }
        </TableCell >
      </Tooltip>)
  })

  return <TableRow sx={{ border: isDuplicateError ? errorBorder : '' }}>
    {itemElement}
  </TableRow>
}
